// api/index.ts - Main API Service Entry Point

import { authAPI, getAuthToken, getRefreshToken, parseJwtPayload, isTokenExpired, type LoginResponse, type AuthPayload, type ApiResponse } from './auth';
import { request, type RequestOptions } from './client';
import {
  usersAPI,
  studentsAPI,
  teachersAPI,
  subjectsAPI,
  classesAPI,
  schedulesAPI,
  gradesAPI,
  assignmentsAPI,
  assignmentSubmissionsAPI,
  attendanceAPI,
  ppdbAPI,
  inventoryAPI,
  eventsAPI,
  eventRegistrationsAPI,
  eventBudgetsAPI,
  eventPhotosAPI,
  eventFeedbackAPI,
  eLibraryAPI,
  fileStorageAPI,
  type FileUploadResponse,
  type UploadProgress,
  announcementsAPI,
  parentsAPI,
  messagesAPI,
  chatAPI,
  paymentsAPI,
  type CreatePaymentRequest,
  type PaymentData,
  type PaymentStatus,
  type PaymentStatusResponse,
} from './modules';
import { auditAPI } from './modules/audit';
import { searchAPI } from './modules/search';
import type { AuditLogEntry, AuditLogFilter, AuditLogExportOptions, AuditLogStats } from './modules/audit';
import type { SearchResult, SearchFilters, SearchResponse, SearchResultType, SavedSearch } from './modules/search';

export type { LoginResponse, ApiResponse, AuthPayload, RequestOptions, FileUploadResponse, UploadProgress, CreatePaymentRequest, PaymentData, PaymentStatus, PaymentStatusResponse, AuditLogEntry, AuditLogFilter, AuditLogExportOptions, AuditLogStats, SearchResult, SearchFilters, SearchResponse, SearchResultType, SavedSearch };

export const apiService = {
  auth: authAPI,
  users: usersAPI,
  students: studentsAPI,
  teachers: teachersAPI,
  subjects: subjectsAPI,
  classes: classesAPI,
  schedules: schedulesAPI,
  grades: gradesAPI,
  assignments: assignmentsAPI,
  assignmentSubmissions: assignmentSubmissionsAPI,
  attendance: attendanceAPI,
  ppdb: ppdbAPI,
  inventory: inventoryAPI,
  events: eventsAPI,
  eventRegistrations: eventRegistrationsAPI,
  eventBudgets: eventBudgetsAPI,
  eventPhotos: eventPhotosAPI,
  eventFeedback: eventFeedbackAPI,
  eLibrary: eLibraryAPI,
  fileStorage: fileStorageAPI,
  announcements: announcementsAPI,
  parents: parentsAPI,
  messages: messagesAPI,
  chat: chatAPI,
  payments: paymentsAPI,
  audit: auditAPI,
  search: searchAPI,
  getAuthToken,
  getRefreshToken,
  parseJwtPayload,
};

export const api = apiService;

export {
  request,
  getAuthToken,
  getRefreshToken,
  parseJwtPayload,
  isTokenExpired,
  authAPI,
  usersAPI,
  studentsAPI,
  teachersAPI,
  subjectsAPI,
  classesAPI,
  schedulesAPI,
  gradesAPI,
  assignmentsAPI,
  assignmentSubmissionsAPI,
  attendanceAPI,
  ppdbAPI,
  inventoryAPI,
  eventsAPI,
  eventRegistrationsAPI,
  eventBudgetsAPI,
  eventPhotosAPI,
  eventFeedbackAPI,
  eLibraryAPI,
  fileStorageAPI,
  announcementsAPI,
  parentsAPI,
  messagesAPI,
  chatAPI,
  paymentsAPI,
  auditAPI,
  searchAPI,
};
